<template>
  <div class="video-item-outer"
       v-on:mouseenter="showDownloadButton"
       v-on:mouseleave="hideDownloadButton"
       v-if="item != null">
    <img :src="'https://obs.zheshi.tech/'+ item.cover_path" @click="posterCoverClicked">
    <div style="text-align: center;font-size: 1.2rem;font-weight: bold;margin-top: 10px;">{{$moment(item.created_at).format('yyyy.MM.DD HH:mm')}}</div>
    <a class="iconfont play-button"
       href="javascript:void(null);"
       @click="playCurrentItem">&#xe6eb;</a>
    <a v-if="showdownload" class="iconfont download" href="javascript:void(null);" @click="downloadButtonClicked">&#xe58a;</a>
<!--    <a v-if="showdownload" class="iconfont download" target="_blank" :href="'https://obs.zheshi.tech/'+ item.video_path" :download="downloadName">&#xe58a;</a>-->
  </div>
</template>

<script>
  import DownloadManager from "../../js/download";
export default {
  name: "VideoItemCard",
  data() {
    return {
      showdownload: false
    }
  },
  props: [
    'item'
  ],
  computed: {
    downloadName() {
      let videoPath = this.item.video_path;
      let gameId = this.item.game_id;
      let extension = videoPath.split('.')[0];
      return gameId + '.' + extension;
    },
  },
  methods: {

    playCurrentItem() {
      this.$emit('play', this.item);
    },
    donwnloadCurrentVideo() {
      window.open(this.item.video_path, '_blank');
    },
    showDownloadButton() {
      this.showdownload = true;
    },
    hideDownloadButton() {
      this.showdownload = false;
    },
    posterCoverClicked() {
      this.showdownload = !this.showdownload;
    },

    downloadButtonClicked() {
      if (this.isWeixin()) {
        this.$message({
          showClose: true,
          message: '请点击右上角，在浏览器打开后下载本视频',
        });
      } else {
        let url = 'https://obs.zheshi.tech/'+ this.item.video_path;
        // let url = 'https://img.shslqxh.com/4399422b-b86f-4966-928a-15ba2de6557a.mp4';
        // let url = 'https://obs.zheshi.tech/default/video/promo.mp4';
        let tmp = url.split('/');
        let filename = tmp[tmp.length - 1];
        DownloadManager.download(url, filename);
      }
    },

  }
}
</script>

<style scoped>

  .video-item-outer {
    position: relative;
    margin-top: 20px;
  }

  .video-item-outer > img {
    /*width: 300px;*/
    width: 40vw;
    min-width: 250px;
    max-width: 500px;
    height: auto;
    min-height: 200px;
    background-color: black
  }

  .video-item-outer .play-button {
    font-size: 2rem;
    font-weight: bold;
    color: white;
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);

    text-decoration: none;

  }

  .video-item-outer .download {
    position: absolute;
    bottom: 45px;
    color: white;
    font-size: 1.5rem;
    right: 15px;
    text-decoration: none;
  }

  .video-item-outer .download:hover {
    color: #fc1a34;
  }


</style>



// WEBPACK FOOTER //
// src/pages/outer-matches/VideoItemCard.vue